import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useBookPurchases = (userId: string | undefined) => {
  return useQuery({
    queryKey: ["book-purchases", userId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("book_purchases")
        .select("book_id")
        .eq("user_id", userId!)
        .eq("status", "paid");
      if (error) throw error;
      return (data ?? []).map((p: any) => p.book_id as string);
    },
    enabled: !!userId,
  });
};

export const useLessonPurchases = (userId: string | undefined) => {
  return useQuery({
    queryKey: ["lesson-purchases", userId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("purchases")
        .select("lesson_id")
        .eq("user_id", userId!);
      if (error) throw error;
      return (data ?? []).map((p: any) => p.lesson_id as string);
    },
    enabled: !!userId,
  });
};
